import { useEffect, useRef, useState } from 'react';

const fmt = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

interface ElapsedTimerProps {
  /** Class applied to the wrapper (e.g. reuse `center-sub`). */
  className?: string;
  /** Suffix after the time, e.g. "0:07 elapsed". */
  label?: string;
}

/**
 * Counts up from its own mount time, updating once a second. Mount it only while a
 * task is in progress (e.g. inside a `status === 'loading'` branch): it starts at
 * 0:00 on mount and the interval is torn down on unmount, so it needs no external
 * start timestamp. Elapsed seconds are derived from the stored start time rather
 * than an incrementing counter, so the display stays correct even if interval ticks
 * are throttled (e.g. a backgrounded tab).
 */
export function ElapsedTimer({ className, label = 'elapsed' }: ElapsedTimerProps) {
  const start = useRef(Date.now());
  const [secs, setSecs] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSecs(Math.floor((Date.now() - start.current) / 1000));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className={className}>
      {fmt(secs)} {label}
    </div>
  );
}
